/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import { Component } from "react";
import { withStyles } from "@material-ui/core/styles/index";
import { Link, withRouter } from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import SettingsIcon from "@material-ui/icons/Settings";
import HelpIcon from "@material-ui/icons/Help";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import LanguageIcon from "@material-ui/icons/Language";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { connect } from "react-redux";
import { logout } from "../../auth/actions";
import { updateStudentLanguage } from "../../users/actions";
import { currentUser, isTherapist } from "../../auth/selectors";
import { isInSession, getTreatment, getCertificationMap } from "../../treatment/selectors";
import { isAnyLoading } from "@app/selectors";
import { fade } from "@material-ui/core/styles/colorManipulator";
import SupportDialog from "@app/common/components/SupportDialog";
import NetworkTestDiag from "@app/common/components/NetworkTestDialog";
import { Tooltip } from "@material-ui/core";
import { ROLES } from "@app/constants";
import { Languages } from "@app/common/data/Languages";
import { trackEvent } from "@amplio-common/analytics";
import { AppContext } from "@app/containers/AppContext";
import { ReactComponent as PoppinsLogo } from "../../../assets/img/poppins_logo.svg";
import { getIsWeakCPU } from "@amplio-common/funcs/commonFunctionalities";
import { ReactComponent as WarningIcon } from "@app/assets/svgs/streamline-icon-alert-triangle.svg";
import WeakCPUDiag from "@app/common/components/WeakCPUDiag";
import { selectIsFullScreen } from "@app/routes/full_screen/store/fullScreenSlice";
import ResetPassDialog from "@app/routes/auth/components/password-reset-dialog";
import { Trans } from "@lingui/macro";
import { Feature } from "flagged";

const styles = theme => ({
  appFrame: {
    position: "relative",
    display: "flex",
    width: "100%",
    height: "100%",
    overflow: "hidden",
    overflowY: "auto",
  },
  appBar: {
    position: "fixed",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    alignItems: "center",
    display: "inline-grid",
    boxShadow: "none",
    height: "60px",
  },
  appBarShift: {
    width: "100%",
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(),
      width: "auto",
    },
  },
  searchIcon: {
    width: theme.spacing(9),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
  },
  inputInput: {
    paddingTop: theme.spacing(),
    paddingRight: theme.spacing(),
    paddingBottom: theme.spacing(),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
  flex: {
    flex: 1,
  },
  menuOptions: {
    flex: 1,
    display: "inline-block",
    marginLeft: "30px",
  },
  menuOption: {
    display: "inline-block",
    borderRadius: "10px",
    marginRight: "15px",
    "&.active": {
      backgroundColor: "#26426E",
    },
    "& button": {
      textTransform: "none",
      "& a": {
        textDecoration: "none",
      },
    },
  },
  hide: {
    display: "none",
  },
  name: {
    display: "inline-block",
  },
  leftSideHeader: {
    minWidth: 600,
  },
  rightSideHeader: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginLeft: "auto",
    flip: false,
    "& .MuiIconButton-label": {
      color: "#2037B5",
    },
  },
  toolbarRoot: {
    minHeight: "60px",
  },
  logout: {
    display: "flex",
    alignItems: "center",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "25px",
    marginRight: "36px",
  },
  newHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "32px",
    width: "184px",
    height: "56px",
    marginTop: "12px",
  },
  newLogo: {
    height: "100px",
    width: "200px",
    boxSizing: "content-box",
  },
  logo: {
    padding: "5px 0",
    marginTop: "5px",
    height: "40px",
    boxSizing: "content-box",
  },
  headerLink: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  progress: {
    marginRight: "15px",
  },
  langMenu: {
    top: "60px",
  },
  langIcon: {
    width: "24px",
    height: "16px",
    marginLeft: "30px",
  },
  menuItem: {
    color: "#0F1140",
    borderBottom: "0.5px solid #707070",
    "&:last-child": {
      borderBottom: "none",
    },
  },
});

class Header extends Component {
  constructor() {
    super();

    this.state = {
      anchorEl: null,
      anchorLangEl: null,
      isSupportOpen: false,
      isSystemCheckDiagOpen: false,
      isPasswordResetDiagOpen: false,
      isWeakCPU: getIsWeakCPU(),
      isShowUnsupportedDiag: false,
    };
  }

  handleMenu = event => {
    trackEvent("settings_icon_clicked");
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  showLangMenu = event => {
    this.setState({ anchorLangEl: event.currentTarget });
  };

  closeLangMenu = () => {
    this.setState({ anchorLangEl: null });
  };

  isActiveRoute = path => this.props.location.pathname.startsWith(path);

  _handle_clinic_selected = () => {};

  openSystemCheckPopUp = () => {
    // // sendActionAnalytics("Overall","System Check");
    // const width = 1000;
    // const height = 800;
    // const left = window.screen.width / 2 - width / 2;
    // const top = window.screen.height / 2 - height / 2;
    // const winStr = `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no,width=${width},height=${height},top=${top},left=${left}`;
    // window.open(SYSTEM_CHECK_URL, "System checks", winStr);
    this.setState({ isSystemCheckDiagOpen: true });
  };

  openResetPasswordPopUp = () => {
    trackEvent("reset_password_chosen");
    this.setState({ isPasswordResetDiagOpen: true });
  };

  onChangeLang = (lang) => {
    this.closeLangMenu();
    this.handleClose();
    this.props.updateLanguage(lang);
  }

  getLogoSRC = () => PoppinsLogo

  checkIfClearLogin = () => { // quick & dirty fix to issues when clicking the logo while on login page
    if (window.location.href.endsWith("login/") || window.location.href.endsWith("login")) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("totp_token");
    }
  }

  render() {
    if (!this.props.currentUser) {
      return <div />;
    }
    const { props } = this;
    const { classes, currentUser, isAnyLoading, isInSession, isTherapist, isFullScreen } = props;
    const { anchorEl, anchorLangEl, isSupportOpen, isSystemCheckDiagOpen, isWeakCPU, isShowUnsupportedDiag, isPasswordResetDiagOpen } = this.state;
    const openMenu = Boolean(anchorEl);
    const openLangMenu = Boolean(anchorLangEl);
    const { allowToSetLanguage } = this.context;

    if (this.props.onlyLogo) {
      return (
        // eslint-disable-next-line no-self-assign
        <div className={classes.newHeader} onClick={() => { if (!currentUser.id) { window.location = window.location; } }}>
          <Link style={{ textDecoration: "none", color: "white" }} to="/" onClick={this.checkIfClearLogin}>
            <PoppinsLogo alt="logo" className={classes.newLogo} />
          </Link>
        </div>
      );
    }

    return (
      <>
        <AppBar style={{ backgroundColor: "#fff", display: isFullScreen ? "none" : "" }} className={classes.appBar}>
          <Toolbar
            classes={{
              root: this.props.classes.toolbarRoot,
            }}
            disableGutters
          >
            <Grid container alignItems="center">
              <Grid item xs={3} className={classes.headerContainer}>
                {/* eslint-disable-next-line no-self-assign */}
                <div onClick={() => { if (!currentUser.id) { window.location = window.location; } }}>
                  <Link style={{ textDecoration: "none", color: "white" }} to="/">
                    <PoppinsLogo style={{ width: "8rem" }} alt="logo" className={classes.logo} data-testid="amplio_logo" />
                  </Link>
                </div>
              </Grid>
              <Grid item xs={9} className={classes.rightSideHeader}>

                { isAnyLoading && <CircularProgress size={20} color="primary" className={classes.progress} /> }
                { isInSession && isTherapist && isWeakCPU && (
                <Tooltip title="Unsupported Device" enterDelay={400} enterNextDelay={400} interactive>
                  <IconButton onClick={() => { this.setState({ isShowUnsupportedDiag: true }); }}>
                    <WarningIcon style={{ padding: 2 }} />
                  </IconButton>
                </Tooltip>
                ) }
                <IconButton onClick={() => { trackEvent("suppport_dialog_open"); this.setState({ isSupportOpen: true }); }} data-testid="info-icon">
                  <HelpIcon />
                </IconButton>

                {(currentUser.id && currentUser.role && currentUser.role === ROLES.STUDENT.id) && (
                <div className={classes.logout}>
                  <IconButton aria-owns="menu-lang" aria-haspopup="true" color="primary" onClick={this.showLangMenu} disabled={!allowToSetLanguage}>
                    <LanguageIcon />
                  </IconButton>
                  <Menu
                    id="menu-lang"
                    anchorEl={anchorLangEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={openLangMenu}
                    onClose={this.closeLangMenu}
                    style={{ top: "50px" }}
                  >
                    {Languages.map((lang) => (
                      <MenuItem data-testid="header-lang-button" key={lang.value} className={classes.menuItem} disabled={currentUser.language_id === lang.value} onClick={() => this.onChangeLang(lang.value)}><ListItemText>{lang.label}</ListItemText><ListItemIcon><img src={lang.icon} className={classes.langIcon} alt="" /></ListItemIcon></MenuItem>
                    ))}
                  </Menu>
                </div>
                )}
                {currentUser.id && (
                <div className={classes.logout} id="Settings" data-testid="Settings">
                  <IconButton aria-owns="menu-appbar" aria-haspopup="true" onClick={this.handleMenu}>
                    <SettingsIcon data-testid="header-profile-icon" />
                  </IconButton>
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={openMenu}
                    onClose={this.handleClose}
                    style={{ top: "50px" }}
                  >
                    { !localStorage.getItem("code_login_token") && (
                    <MenuItem className="classes.menuItem" data-testid="header-logout-button" disabled>
                      <Typography variant="subtitle1" color="inherit">
                        {currentUser.name}
                      </Typography>
                    </MenuItem>
                    )}

                    <MenuItem className={classes.menuItem} data-testid="header-logout-button" onClick={this.openSystemCheckPopUp}>
                      <Trans>System Check</Trans>
                    </MenuItem>
                    {["credentials"].includes(currentUser.auth_type) && (
                      <Feature name="RESET_PASSWORD">
                        <MenuItem className={classes.menuItem} data-testid="header-logout-button" onClick={this.openResetPasswordPopUp}>
                          <Trans>Reset Password</Trans>
                        </MenuItem>
                      </Feature>
                    )}
                    <MenuItem
                      className={classes.menuItem}
                      data-testid="header-logout-button"
                      onClick={e => {
                        this.props.logout();
                        this.handleClose(e);
                        this.closeLangMenu(e);
                        // this.sendActionAnalytics("Overall","Logout Clicked");
                      }}
                    >
                      <Trans>Logout</Trans>
                    </MenuItem>
                  </Menu>
                </div>
                )}
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>

        { isShowUnsupportedDiag && <WeakCPUDiag cancelAction={() => this.setState({ isShowUnsupportedDiag: false })} />}

        { isSupportOpen && (
        <SupportDialog closeDialog={() => this.setState({ isSupportOpen: false })} />
        )}

        { isSystemCheckDiagOpen && (
        <NetworkTestDiag closeDialog={() => this.setState({ isSystemCheckDiagOpen: false })} />
        )}

        { isPasswordResetDiagOpen && (
        <ResetPassDialog
          user={currentUser}
          closeDialog={() => {
            trackEvent("create_password_window_closed");
            this.setState({ isPasswordResetDiagOpen: false });
          }}
        />
        )}

        {/* <Feature name="PASSWORD_EXPIRATION">
          <PasswordChangeNotification
            user={currentUser}
            onChangePass={() => this.setState({ isPasswordResetDiagOpen: true })}
          />
        </Feature> */}
      </>
    );
  }
}

const mapStateToProps = state => ({
  currentUser: currentUser(state),
  isInSession: isInSession(state),
  isTherapist: isTherapist(state),
  treatment: getTreatment(state),
  certificationMap: getCertificationMap(state),
  isAnyLoading: isAnyLoading(state),
  clinics: state.clinics.items,
  anchorEl: state.anchorEl,
  anchorLangEl: state.anchorLangEl,
  isFullScreen: selectIsFullScreen(state),
});

Header.contextType = AppContext;

export default withRouter(
  connect(mapStateToProps, { logout: logout.request, updateLanguage: updateStudentLanguage.request })(withStyles(styles, { withTheme: true })(Header)),
);
